import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Country } from 'src/app/interfaces/country';

import { User } from 'src/app/interfaces/user';
import { ClientCompany } from 'src/app/interfaces/client';
import { Role } from 'src/app/interfaces/role';

@Injectable({
  providedIn: 'root',
})
export class ReferenceService {
  api: string;
  constructor(private http: HttpClient) {
    this.api = `${environment.api}/references`;
  }
  countries() {
    return this.http.get<Country[]>(`${this.api}/countries`, {
      observe: 'body',
    });
  }
  locations() {
    return this.http.get<any[]>(`${this.api}/locations`, { observe: 'body' });
  }
  sales_rep() {
    return this.http.get<User[]>(`${this.api}/sales_rep`, { observe: 'body' });
  }
  companies(category?: "academe" | "industrial") {
    let params = new HttpParams()
    category && (params = params.append("category", category));
    return this.http.get<ClientCompany[]>(
      `${this.api}/companies`,
      {
        observe: 'body',
        params: params
      }
    );
  }
  roles() {
    return this.http.get<Role[]>(`${this.api}/roles`)
  }
}
